import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import useTextStyles from 'styles/useTextStyles'
import { useState, useEffect } from 'react'

type Props = {
  currentMonth: number
  currentYear: number
  setCurrentMonth: (date: { month: number; year: number }) => void
  className?: string
}

export const MonthSelect = ({ currentMonth, currentYear, setCurrentMonth, className }: Props) => {
  const months = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro'
  ]

  const formatYear = (year: number) => year.toString().slice(-2)

  const generateMonthList = () => {
    const monthList = [{ name: 'Mês Atual', month: currentMonth, year: currentYear }]
    for (let i = 1; i <= 11; i++) {
      const monthIndex = (currentMonth - i - 1 + 12) % 12
      const yearOffset = i >= currentMonth ? 1 : 0
      const year = currentYear - yearOffset
      const monthName = `${months[monthIndex]} ${formatYear(year)}`
      monthList.push({ name: monthName, month: monthIndex + 1, year })
    }
    return monthList
  }

  const [filteredMonths, setFilteredMonths] = useState(generateMonthList())

  useEffect(() => {
    setFilteredMonths(generateMonthList())
  }, [])

  const handleChange = (event: SelectChangeEvent<number>) => {
    const selectedMonth = filteredMonths.find((month) => month.month === Number(event.target.value))
    if (selectedMonth) {
      setCurrentMonth({ month: selectedMonth.month, year: selectedMonth.year })
    }
  }

  return (
    <FormControl className="w-full">
      <InputLabel id="select-date">Período</InputLabel>
      <Select
        id="select-date"
        value={currentMonth}
        label="Período"
        onChange={handleChange}
        sx={{
          '& .MuiSvgIcon-root': {
            left: '8px'
          },
          paddingLeft: '35px',
          ...useTextStyles.bodyLarge
        }}
        className={className}
      >
        {filteredMonths.map((month, index) => (
          <MenuItem key={index} value={month.month}>
            {month.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
